import { styled } from "styled-components";

export const FooterComponent = styled.footer`
  padding: 60px 0;
  border-top: 1px solid #dfdfdf;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;

export const FooterContentWrap = styled.div`
  display: flex;
  gap: 120px;
  margin-bottom: 16px;
  @media all and (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 2.604vw;
  }
`;
export const FooterIconListWrap = styled.ul`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 48px;
  li {
    a {
      background-color: #171717;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  @media all and (max-width: 768px) {
    gap: 3.125vw;
    margin-bottom: 5.208vw;
    li {
      a {
        width: 7.552vw;
        height: 7.552vw;
        img {
          width: 4.688vw;
          height: 4.688vw;
        }
      }
    }
  }
`;
export const FooterCopyText = styled.p`
  color: #242424;
  font-size: 14px;
  @media all and (max-width: 768px) {
    font-size: 3.125vw;
  }
`;

export const FooterLocationListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  > h6 {
    color: #242424;
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
  }
  p {
    color: #242424;
    font-size: 14px;
    line-height: 1.6;
  }
  @media all and (max-width: 768px) {
    > h6 {
      font-size: 3.385vw;
    }
    p {
      font-size: 3.125vw;
    }
  }
`;
export const FooterInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  p {
    color: #242424;
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
  }
  img {
    width: 260px;
    height: 35px;
  }
  @media all and (max-width: 768px) {
    p {
      font-size: 3.385vw;
    }
    img {
      width: 41.667vw;
      height: 4.557vw;
    }
  }
`;
